import React from "react";
import Select from "react-select";
import Firebase from "../../firebasehelper";

class AddUmbrellaAdminModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      brand: {},
      brands: [],
    };
  }

  componentDidMount() {
    Firebase.getAllBrands((brands) => {
      const filteredBrands = brands
        .map((obj, index) => ({ ...obj, index }))
        .filter((item) => !item.deactive && item.umbrella);
      filteredBrands.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.setState({ brands: filteredBrands });
    });
  }

  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  addUser = () => {
    const { name, email, brand } = this.state;
    const { addUser } = this.props;
    addUser(name, email, brand.value);
  };

  render() {
    const { name, email, brand, brands } = this.state;
    return (
      <div
        className="modal fade"
        id="addsubadmin_user"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Umbrella Admin</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-name"
                  name="name"
                  placeholder="Full Name"
                  onChange={this.onChangeHandler}
                  value={name}
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-email"
                  name="email"
                  placeholder="Email"
                  onChange={this.onChangeHandler}
                  value={email}
                />
              </div>
              <div className="form-group">
                <label>Select an umbrella brand</label>
                <Select
                  options={brands.map((obj) => ({
                    value: obj.index,
                    label: obj.name,
                  }))}
                  onChange={(obj) => this.setState({ brand: obj })}
                  value={brand}
                  placeholder="Brand"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.addUser}
              >
                Invite
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddUmbrellaAdminModal;



// WEBPACK FOOTER //
// ./src/components/AddUmbrellaAdminModal/index.js